import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import moment from 'moment';

//Components
import Loading from '../../../components/Loading/Loading';
import MainCard from '../../../components/MainCard/MainCard';
import TextField from '../../../components/TextField/TextField';
import RelatorioGeradoresSemColeta from './RelatorioGeradoresSemColeta';

//Helpers
import { validarCampos, objCampo, PrintValidate } from '../../../helpers/ValidadorDeCampos';
import { showMessage } from '../../../helpers/message';
import mascaras from '../../../helpers/mascaras';

//Api
import modalidadeColeta_api from '../../../api/modalidadeColeta_api';
import relatorio_api from '../../../api/relatorio_api';

function initialStateFiltros() {
    const dataAtual = new Date();

    dataAtual.setMonth(dataAtual.getMonth() - 1);
    const dataInicial = moment(dataAtual).format("YYYY-MM-DD");

    dataAtual.setMonth(dataAtual.getMonth() + 1);
    dataAtual.setDate(dataAtual.getDate() - 1);
    const dataFinal = moment(dataAtual).format("YYYY-MM-DD");

    return {
        dataInicial,
        dataFinal,
        modalidadeId: 0,
        modalidadeId_selected: null,
        cnpj: "",
        nomeRelatorio: "Relatórios - Geradores Sem Coleta"
    }
}

export default function GeradoresSemColeta() {
    //Variavel utilizada para navegação 
    const navigate = useNavigate();

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Estado de controle dos erros nos campos obrigatorios
    const [errors, setErrors] = useState({});

    //Estado de controle dos valores dos filtros
    const [filtros, setFiltros] = useState(initialStateFiltros());

    //Opções de modalidades de coleta
    const [optionsModalidades, setOptionsModalidades] = useState([]);

    //Estado que guarda os dados do relatorio
    const [dadosRelatorio, setDadosRelatorio] = useState([]);

    const loadModalidades = () => {
        setLoading(true);
        modalidadeColeta_api.GetList().then(response => {
            response.data = response.data.map(value => {
                return { value: value.id, label: value.descricao };
            });
            setOptionsModalidades(response.data);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    useEffect(() => {
        loadModalidades();
    }, []);

    //Guarda os filtros obrigatorios
    const campos = [
        objCampo({ name: "dataInicial", required: true }),
        objCampo({ name: "dataFinal", required: true }),
        objCampo({ name: "modalidadeId", required: true }),
    ]

    //Change para os campos data inicial, data final e status
    const onChangeFiltros = (e) => {
        const { name, value } = e.target;
        setFiltros({
            ...filtros,
            [name]: value
        })
    }

    //Change para os campos modalidade e localidade
    const onChangeSelected = (e, select) => {
        const { name } = select;
        setFiltros({
            ...filtros,
            [name]: e,
            [name.split("_")[0]]: e ? e.value.toString() : 0,
        });
    }

    //Função que puxa os dados do relatorio
    const carregarRelatorio = () => {

        const _errors = validarCampos(filtros, campos);

        if (_errors[1].length > 0) {
            setErrors(_errors[0]);
            return;
        }

        if (new Date(filtros.dataInicial).getTime() > new Date(filtros.dataFinal).getTime()) {
            setErrors({ dataInicial: { message: "A data inicial não pode ser maior do que a data final" } })
            return;
        } else {
            setErrors({});
        }
        setLoading(true);
        relatorio_api.GeradoresSemColeta(filtros).then(response => {
            setDadosRelatorio(response.data);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    if (dadosRelatorio.length > 0) {
        return <RelatorioGeradoresSemColeta
            dadosRelatorio={dadosRelatorio}
            btnVoltar={() => setDadosRelatorio([])}
            filtros={filtros}
        />
    }

    return <MainCard btnVoltarInTop={() => navigate(-1)}>
        {loading && <Loading />}
        <h4>Relatório de geradores sem coleta</h4>
        <Row>
            <Col sm="12" md="6" lg="4">
                <TextField
                    name="dataInicial"
                    label={"* Data inicial"}
                    type={"date"}
                    value={filtros.dataInicial}
                    onChange={onChangeFiltros}
                    invalid={!!errors.dataInicial}
                />
                <PrintValidate field={"dataInicial"} errors={errors} />
            </Col>
            <Col sm="12" md="6" lg="4">
                <TextField
                    name="dataFinal"
                    label={"* Data final"}
                    type={"date"}
                    value={filtros.dataFinal}
                    onChange={onChangeFiltros}
                    invalid={!!errors.dataFinal}
                />
                <PrintValidate field={"dataFinal"} errors={errors} />
            </Col>
            <Col sm="12" md="6" lg="4">
                <TextField
                    name="cnpj"
                    label={"CNPJ"}
                    type={"text"}
                    mask={mascaras.cnpjMask}
                    maxLength={18}
                    value={filtros.cnpj}
                    onChange={onChangeFiltros}
                    invalid={!!errors.cnpj}
                />
                <PrintValidate field={"cpfcnpj"} errors={errors} />
            </Col>
            <Col sm="12" md="6" lg="4">
                <TextField
                    placeholder='Selecione'
                    name="modalidadeId_selected"
                    label={"* Modalidade"}
                    type={"select"}
                    searchable
                    value={optionsModalidades.filter(x => x.value == filtros.modalidadeId)}
                    invalid={!!errors.modalidadeId}
                    onChange={onChangeSelected}
                    options={optionsModalidades}
                />
                <PrintValidate field={"modalidadeId"} errors={errors} />
            </Col>
            <Col sm="12" md="6" lg="4" style={{ marginTop: "1.875rem" }}>
                <Button
                    className='w-100 fw-bold'
                    color='info text-light'
                    onClick={carregarRelatorio}
                >
                    Gerar Relatório
                </Button>
            </Col>
        </Row>
    </MainCard>;
}